import { __assign, __awaiter, __generator } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { applyOfficeIdentity, httpPut } from '@office-start/xhr-service';
import * as Cookies from 'es-cookie';
import { getMasterCollection } from '../UserStorageService';
export function setUserStorageItem(key, value, options) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var masterCollection, identity, requestConfig, csrfToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    masterCollection = getMasterCollection();
                    // Cache supplied value in memory for quick retrieval
                    masterCollection[key] = Array.isArray(value) ? value : __assign({}, value);
                    return [4 /*yield*/, options.getIdentity()];
                case 1:
                    identity = _a.sent();
                    // Check if there is remote service
                    if (options.jwtAuthEnabled && identity.isMsa) {
                        reject('User storage does not support roaming');
                        return [2 /*return*/];
                    }
                    requestConfig = { headers: {} };
                    // TODO: axios accepts a cookie and header for this purpose.
                    if (!options.inMockMode && !options.jwtAuthEnabled) {
                        csrfToken = Cookies.get('AjaxSessionKey');
                        if (csrfToken) {
                            requestConfig.headers['AjaxSessionKey'] = csrfToken;
                        }
                        else {
                            logErrorEvent(KnownInstrumentationEvents.CsrfTokenError);
                            logError({
                                eventName: "Csrf_Token" /* CsrfTokenError */,
                                errorType: 'User_Storage_Error',
                            });
                            reject('CSRF token missing');
                            return [2 /*return*/];
                        }
                    }
                    return [4 /*yield*/, applyOfficeIdentity(requestConfig, options.inMockMode, options.workload, options.getIdentity)];
                case 2:
                    _a.sent();
                    // IMPORTANT: Note that url has trailing '/', this is required because key can have '.' symbol and IIS may interpret
                    // the url as file location. This will certainly return 404 and IIS error page
                    // IMPORTANT: Metrics are not recorded on purpose. This is done due to the fact that setting metrics
                    // will invalidate user profile. This will trigger user storage write operation for the updated user profile.
                    // This will create self-feeding cycle:
                    //      user storage read operation -> instrumented with metrics ->
                    //      user profile updated -> user profile stored -> user storage write operation
                    // TODO: Defer using xhr service with scheduler
                    httpPut(KnownInstrumentationEvents.OfficeHomeStorageWriteRequest, options.officeHomeApiRoot + "/api/userstorage/" + key + "/", value, requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeHomeApiRoot, options.correlationId, "OfficeHome" /* OfficeHome */, {
                        populateRequestEvent: function (_result, params) {
                            params["ElementId" /* ElementId */] = key;
                        },
                    })
                        .then(function () { return resolve(); })
                        .catch(function (error) {
                        // Pass caught error to global handler to ensure that it is properly logged in case it is code error
                        getErrorHandler().handleError(error, "J7GBR" /* J7GBR */);
                        reject("Failed to update or create value in roaming user data storage for <" + key + "> key.");
                    });
                    return [2 /*return*/];
            }
        });
    }); });
}
//# sourceMappingURL=setUserStorageItem.js.map